export function toTop() {
  $(".footer_ .to-top-btn").on("click", function(event) {
    event.preventDefault();
    $("html, body").animate({
      scrollTop: $("body").offset().top
    }, 700);
  });
}



// WEBPACK FOOTER //
// ./assets/js/modules/toTop.js